const initTabs = () => {
  const tabsWrapper = document.getElementById('product-tabs-wrapper');
  const layout = tabsWrapper.dataset.layout;
  const tabsButtons = Array.from(document.querySelectorAll('ul.tabs .tab-item > .button-tab'));
 
  const extractIdFromTab = (tab) => (
    tab.getAttribute('href').substring(1)
  );

  const deactivateTab = (tab, tabsContent = []) => {
    tab.classList.remove('active');
    tabsContent.forEach(tabContent => {
      tabContent.classList.remove('active');
    });
  };

  const activateTabById = (tabId) => {
    const selectedTabsButton = tabsButtons.filter((t) => extractIdFromTab(t) === tabId);
    const selectedTabsContent = Array.from(document.getElementsByClassName(tabId));

    if (selectedTabsButton.length > 0 && (selectedTabsButton.length === selectedTabsContent.length)) {
      selectedTabsButton.forEach(selectedTabButton => selectedTabButton.classList.add('active'));
      selectedTabsContent.forEach(selectedTabContent => selectedTabContent.classList.add('active'));
    }
  };

  const deactivateAllTabs = () => {
    tabsButtons.forEach((tab) => deactivateTab(tab, Array.from(document.getElementsByClassName(extractIdFromTab(tab)))));
  };

  const handleTabClick = (event) => {
    
    event.preventDefault();
    const tab = event.currentTarget;
    const tabId = extractIdFromTab(tab);

    if (layout === 'tabs') {
      deactivateAllTabs();
      activateTabById(tabId);
    } else if (layout === 'accordion') {
      const isActive = tab.classList.contains('active');
      deactivateAllTabs();
      if (!isActive) {
        activateTabById(tabId);
      }
    }
  };

  tabsButtons.forEach((tab) => tab.addEventListener('click', handleTabClick));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initTabs);
} else {
  initTabs();
}